import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/worksheet', [
    {
      path: '',
      name: 'worksheet-list',
      component: () => import('@/views/worksheet/WorksheetList.vue'),
    },
    {
      path: '/:worksheet(\\d+)',
      name: 'worksheet-table',
      component: () => import('@/views/worksheet/WorksheetTable.vue'),
    },
  ]);
};
